"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTokenAuthHeader = void 0;
function generateTokenAuthHeader(token) {
    return token.token_type + " " + token.access_token;
}
exports.generateTokenAuthHeader = generateTokenAuthHeader;
